import React, { useEffect, useMemo, useState } from 'react';
import ReportNote from '../components/ReportNote';

const API = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8000';

export default function AbeReviewPage() {
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');
  const [savingKey, setSavingKey] = useState(null);

  const load = () => {
    setLoading(true);
    fetch(`${API}/api/abe/issues`)
      .then(r => r.json()).then(d => { setIssues(d); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const toggle = (issue_key, next) => {
    setIssues(prev => prev.map(i => i.issue_key === issue_key ? { ...i, included: next } : i));
    setSavingKey(issue_key);
    fetch(`${API}/api/abe/issues/${issue_key}?included=${next}`, { method: 'POST' })
      .catch(() => { setIssues(prev => prev.map(i => i.issue_key === issue_key ? { ...i, included: !next } : i)); })
      .finally(() => setSavingKey(null));
  };

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return issues;
    return issues.filter(i =>
      i.issue_key.toLowerCase().includes(term) ||
      i.summary.toLowerCase().includes(term) ||
      i.assignee.toLowerCase().includes(term) ||
      i.reporter.toLowerCase().includes(term)
    );
  }, [issues, q]);

  const includedCount = issues.filter(i => i.included).length;

  return (
    <div>
      <ReportNote what="Choose which ABE (internal) tickets should count as ordinary work in the Team KPI and Billable reports, instead of being excluded." />

      <div className="no-print" style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 24, flexWrap: 'wrap' }}>
        <input
          value={q} onChange={e => setQ(e.target.value)}
          placeholder="Search by key or summary…"
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--text)', minWidth: 260 }}
        />
        <span style={{ fontSize: 12, color: 'var(--text-3)' }}>
          {includedCount} of {issues.length} ticket{issues.length === 1 ? '' : 's'} included
        </span>
      </div>

      {loading && <div className="loading">Loading ABE tickets…</div>}

      {!loading && (
        <div className="card">
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Ticket</th>
                  <th>Summary</th>
                  <th>Assignee</th>
                  <th>Reporter</th>
                  <th style={{ textAlign: 'right' }}>Total Time</th>
                  <th style={{ textAlign: 'center' }}>Include in KPI</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(i => (
                  <tr key={i.issue_key}>
                    <td style={{ fontFamily: 'DM Mono, monospace', fontWeight: 600, whiteSpace: 'nowrap' }}>{i.issue_key}</td>
                    <td style={{ color: 'var(--text-2)' }}>{i.summary || '—'}</td>
                    <td style={{ color: 'var(--text-2)', whiteSpace: 'nowrap' }}>{i.assignee}</td>
                    <td style={{ color: 'var(--text-3)', whiteSpace: 'nowrap' }}>{i.reporter || '—'}</td>
                    <td style={{ textAlign: 'right', fontFamily: 'DM Mono, monospace', color: 'var(--text-3)' }}>{i.total_display}</td>
                    <td style={{ textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={i.included}
                        disabled={savingKey === i.issue_key}
                        onChange={e => toggle(i.issue_key, e.target.checked)}
                        style={{ width: 16, height: 16, cursor: 'pointer' }}
                      />
                    </td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={6} style={{ textAlign: 'center', color: 'var(--text-3)', padding: 20 }}>No tickets match “{q}”.</td></tr>
                )}
              </tbody>
            </table>
          </div>
          <div style={{ marginTop: 14, fontSize: 11, color: 'var(--text-3)', borderTop: '1px solid var(--border)', paddingTop: 10 }}>
            Sorted by total time logged, so the tickets most worth a look are at the top. Checking a ticket makes its time count as ordinary (non-billable) work everywhere ABE- is normally excluded — Team KPI's Target/Fill Rate/Lost % and the Billable Report. It is never counted as billable, even if that ticket's own Billable checkbox is ticked.
          </div>
        </div>
      )}
    </div>
  );
}
